import { createContext, useContext } from 'react'

import { CRBLicensesList } from '~bank-crb-monitor/types'

type CRBPanelContextValue = {
  data: CRBLicensesList
  selectedLicense: number
  setSelectedLicense: (id: number) => void
}

export const CRBPanelContext = createContext<CRBPanelContextValue | undefined>(undefined)

export const useCRBPanelContext = () => {
  const context = useContext(CRBPanelContext)
  if (!context) {
    throw new Error('useCRBPanelContext must be used within a CRBPanelContext.Provider')
  }
  return context
}
